<mat-sidenav-container *ngIf="psnbUser || unauthorizedPath" class="sidenav-container mat-app-background"
                       [ngClass]="{'dark-theme-mode': isDarkTheme}">
  <mat-toolbar color="primary" class="headerPos">
    <!--Header appended here-->
    <nwt-power-supply-nav-bar></nwt-power-supply-nav-bar>
  </mat-toolbar>
  <!--Container appended here-->
  <!-- <div style="height:90%;overflow: auto;"> -->
    <div style="overflow: auto;">
    <router-outlet></router-outlet>
  </div>
  <br><br><br>
  <mat-toolbar class="toolbarNav" color="primary">
    <!-- <nwt-power-supply-bottom-nav-bar></nwt-power-supply-bottom-nav-bar> -->
    <mat-icon class="material-icons"></mat-icon>
    <mat-slide-toggle *ngIf="isHomePage" labelPosition="before" [(ngModel)]="isDarkTheme" (change)="themeSelection()">
      <span class="status">
        <!-- {{ isDarkTheme == true ? 'Dark Mode' : 'Light Mode' }} -->
      <div *ngIf ="isDarkTheme">
        <mat-icon id="switchps" class="material-icons">nights_stay</mat-icon>
      </div>
      <div *ngIf ="!isDarkTheme">
        <mat-icon class="material-icons">wb_sunny</mat-icon>
       </div>

      </span>
    </mat-slide-toggle>
    <div *ngIf="isDetailPage || isListPage">
      <div class="icon_cls_src_listdet" routerLink="/pssearch">
        <button id="search_cls" style="color:white;" mat-mini-fab matSuffix>
          <!-- <mat-icon id="srcps">search</mat-icon> -->
          <a style="font-size: 1.53em;"><i class="fa fa-search" aria-hidden="true"></i></a>
        </button>
        <p class="icon_cls_srclab">Search</p>
      </div>

      <div *ngIf="isListPage" class="icon_cls_src_save">
        <button routerLink="/pssearch" id="search_cls" style="color:white;" mat-mini-fab matSuffix>
          <a style="font-size: 1.83em;"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i></a>
        </button>
        <p class="icon_cls_srclab_edit">Back</p>
      </div>


      <div *ngIf="isDetailPage" class="icon_cls_src_save">
        <button (click)="goBack()" id="search_cls" style="color:white;" mat-mini-fab matSuffix>
          <a style="font-size: 1.83em;"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i></a>
        </button>
        <p class="icon_cls_srclab_edit">Back</p>
      </div>
    </div>

    <div *ngIf="isAssetSearchResultsPage">
      <div class="icon_cls_src_listdet" routerLink="/generatorsearch">
        <button aria-label="Create" class="search_cls" mat-mini-fab matSuffix (click)="openCreateAssetDialog()">
          <a class="create-icon"><span aria-hidden="true" class="fa fa-plus"></span></a>
        </button>
        <p class="icon_cls_srclab">Create</p>
      </div>


      <div *ngIf="isAssetSearchResultsPage" class="icon_cls_src_save">
        <button aria-label="Back" class="search_cls" mat-mini-fab matSuffix (click)="goBack()">
          <span aria-hidden="true" class="back-icon fa fa-arrow-circle-left"></span>
        </button>
        <p class="icon_cls_srclab_edit">Back</p>
      </div>
    </div>


    <div *ngIf="telemetryAlertPage">
      <div *ngIf="telemetryAlertPage" class="icon_cls_src_listdet" routerLink="/pssearch">
        <button id="search_cls" style="color:white;" mat-mini-fab matSuffix>
          <!-- <mat-icon id="srcps">search</mat-icon> -->
          <a style="font-size: 1.53em;"><i class="fa fa-search" aria-hidden="true"></i></a>
        </button>
        <p class="icon_cls_srclab">Search</p>
      </div>


      <div *ngIf="telemetryAlertPage" class="icon_cls_src_save">
        <button (click)="goBack()" id="search_cls" style="color:white;" mat-mini-fab matSuffix>
          <a style="font-size: 1.83em;"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i></a>
        </button>
        <p class="icon_cls_srclab_edit">Back</p>
      </div>


    </div>




    <div *ngIf="isCreatePage">
      <div *ngIf="showCreatePS == 1?false:true" class="icon_cls_src_listdet">
        <button id="search_cls" [disabled]="showCreatePS==2" (click)="routeToCreate()" style="color:white;" mat-mini-fab matSuffix>
          <a style="font-size: 1.63em;"><i class="fa fa-plus" aria-hidden="true"></i></a>
        </button>
        <p class="icon_cls_srclab">Create PS</p>
      </div>

      <div *ngIf="showCreatePS == 1" class="icon_cls_src_save_new">
        <button (click)="goBack()" id="search_cls" style="color:white;" mat-mini-fab matSuffix>
          <a style="font-size: 1.73em;"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i></a>
        </button>
        <p class="icon_cls_srclab_edit">Back</p>
      </div>

      <div *ngIf="showCreatePS != 1" class="icon_cls_src_save">
        <button (click)="goBack()" id="search_cls" style="color:white;" mat-mini-fab matSuffix>
          <a style="font-size: 1.73em;"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i></a>
        </button>
        <p class="icon_cls_srclab_edit">Back</p>
      </div>
    </div>

      <div *ngIf="createAEdit">
          <div *ngIf="showCreatePS == 1?false:true" class="icon_cls_src_listdet">
              <button id="search_cls" (click)="routeToCreate()" style="color:white;" mat-mini-fab matSuffix>
                  <a style="font-size: 1.63em;"><i class="fa fa-plus" aria-hidden="true"></i></a>
              </button>
              <p class="icon_cls_srclab">Create PS</p>
          </div>

          <div *ngIf="showCreatePS == 1" class="icon_cls_src_save_new">
            <button routerLink="/pssearch" id="search_cls" style="color:white;" mat-mini-fab matSuffix>
                <a style="font-size: 1.73em;"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i></a>
            </button>
            <p class="icon_cls_srclab_edit">Back</p>
          </div>

          <div *ngIf="showCreatePS != 1" class="icon_cls_src_save">
              <button routerLink="/pssearch" id="search_cls" style="color:white;" mat-mini-fab matSuffix>
                  <a style="font-size: 1.73em;"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i></a>
              </button>
              <p class="icon_cls_srclab_edit">Back</p>
          </div>
      </div>

    <div *ngIf="isCreateSavePage">
      <div class="icon_cls_src_edit">
        <button (click)="goBack()" id="search_cls" style="color:white;" mat-mini-fab matSuffix>
          <a style="font-size: 1.73em;"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i></a>
        </button>
      </div>
      <p class="icon_cls_srclab_edit">Back</p>
      <div class="icon_cls_src_save" >
        <button [disabled]="(createDisableButtonObj['createlocform'])" (click)="submitCreateAction($event)" style="color:white;" mat-mini-fab matSuffix>
          <!-- <mat-icon>save_all</mat-icon> -->
          <a style="font-size: 1.73em;"><i class="fa fa-save" aria-hidden="true"></i></a>
        </button>
      </div>
       <div class="icon_cls_srclab_save">Create</div>
    </div>

    <div *ngIf="isAssetCreatePage">
      <div class="icon_cls_src_edit">
        <button aria-label="Back" class="search_cls" mat-mini-fab matSuffix (click)="goBack()">
          <span aria-hidden="true" class="back-icon fa fa-arrow-circle-left"></span>
        </button>
      </div>
      <p class="icon_cls_srclab_edit">Back</p>
      <div class="icon_cls_src_save">
        <button 
          aria-label="Create" 
          class="search_cls" 
          mat-mini-fab 
          matSuffix 
          [disabled]="createDisableButtonObj['createlocform']" 
          (click)="submitCreateAction($event)">
          <span aria-hidden="true" class="save-icon fa fa-save"></span>
        </button>
      </div>
       <div class="icon_cls_srclab_save">Create</div>
    </div>

    <div *ngIf="isAssetEditPage">
      <div class="icon_cls_src_edit">
        <button aria-label="Back" class="search_cls" mat-mini-fab matSuffix (click)="goBack()">
          <span aria-hidden="true" class="back-icon fa fa-arrow-circle-left"></span>
        </button>
      </div>
      <p class="icon_cls_srclab_edit">Back</p>
      <div class="icon_cls_src_save">
        <button 
          aria-label="Save" 
          class="search_cls" 
          mat-mini-fab 
          matSuffix 
          [disabled]="generatorEditDisableButtonObj['generatorEditForm']" 
          (click)="submitGeneratorEditAction($event)">
          <span aria-hidden="true" class="save-icon fa fa-save"></span>
        </button>
      </div>
       <div class="icon_cls_srclab_save">Save</div>
    </div>



    <div *ngIf="isEditPage">
      <div class="icon_cls_src_edit">
        <button (click)="goBack()" id="search_cls" style="color:white;" mat-mini-fab matSuffix>
          <a style="font-size: 1.73em;"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i></a>
        </button>
      </div>
      <p class="icon_cls_srclab_edit">Back</p>
      <div class="icon_cls_src_save" >
        <button [disabled]="(disableButtonObj['locform'])" (click)="submitAction($event)" style="color:white;" mat-mini-fab matSuffix>
          <!-- <mat-icon>save_all</mat-icon> -->
          <i style="font-size: 1.73em;" class="fa fa-save" aria-hidden="true"></i>
        </button>
      </div>
       <div class="icon_cls_srclab_save">Save</div>

    </div>
   <mat-icon class="material-icons"></mat-icon>
  </mat-toolbar>
</mat-sidenav-container>
<div *ngIf="message">{{ message }}</div>
